import { Component, Input,  OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { StylingService, Theme } from 'src/app/services/style-service/styling.service';
import { IframeRecivedService } from 'src/app/shared/navbar/navbar-vesax/iframe-recieved.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-laptop-modal',
  templateUrl: './laptop-modal.component.html',
  styleUrls: ['./laptop-modal.component.scss'],
  standalone:false
})
export class LaptopModalComponent implements OnInit {
  @Input() isOpen = false;
  iframeSrc: SafeResourceUrl='';
  constructor(
    public styleService: StylingService,
    public iframeService:IframeRecivedService,
    private sanitizer: DomSanitizer
  ) { 
    this.iframeSrc = `${environment.designerIframe}home/5-294f94-ffffff-erslpngc-&amp;lid-214601-&amp`;
  }

  ngOnInit(): void {
    this.iframeService.styleTypeSub.subscribe((styleType) => {
      this.setIframe(styleType ?? 2);
    });
  }

  setIframe(styleType: number) {
    let url =''
    if(styleType===0){
      url = `${environment.designerIframe}home/0-294f94-ffffff-erslpngc-&amp;lid-214601-&amp`
    }else if(styleType===1){
      url = `${environment.designerIframe}home/1-294f94-ffffff-erslpngc-&amp;lid-214601-&amp`;
    }else if(styleType==5 || styleType==2){
      url = `${environment.designerIframe}home/5-294f94-ffffff-erslpngc-&amp;lid-214601-&amp`;
    }else if(styleType==6 || styleType==4){
      url = `${environment.designerIframe}home/6-294f94-ffffff-erslpngc-&amp;lid-214601-&amp`;
    }

    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }


  public get theme(): typeof Theme {
    return Theme;
  }
}
